import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-unit-overview',
  templateUrl: './unit-overview.component.html',
  styleUrl: './unit-overview.component.scss',
})
export class UnitOverviewComponent implements AfterViewInit {
  @ViewChild('iframe') iframe!: ElementRef;
  vin: string | null = null;
  iframeUrl: SafeResourceUrl = '';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
    this.route.queryParamMap.subscribe((params) => {
      this.vin = params.get('vin');
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://unitoverview-ui-oasis-oasiszadev-mnng.scp.eu-central-1.aws.cloud.bmw/?vin=${this.vin}`

      );
    });
  }

  ngAfterViewInit() {
    if (this.iframe && this.vin) {
      const iframeWindow = this.iframe.nativeElement.contentWindow;
      iframeWindow.postMessage(
        { vin: this.vin },
        'https://unitoverview-ui-oasis-oasiszadev-mnng.scp.eu-central-1.aws.cloud.bmw/'
      );
    }
  }
}
